import type { ComponentProps } from 'react';
import { Button } from '@/shared/components';
import ExchangeRotateIcon from '@/shared/assets/exchange-rotate-icon.svg?react';

type Props = ComponentProps<'button'>;

const ExchangeRotateButton = (props: Props) => {
  return (
    <Button
      {...props}
      type="button"
      variant="secondary"
      className="rounded-full size-[3.6rem] p-0">
      <ExchangeRotateIcon className="size-[2.4rem]" />
    </Button>
  );
};

export { ExchangeRotateButton };
